import { FunctionComponent } from 'react'
import Modal from '@/components/Modal'
import { Button } from '@conexasaude/hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'

const AttendanceLate: FunctionComponent = () => {
  const { closeModal } = useModalContext()

  return (
    <Modal id="ATTENDANCE_LATE">
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p className="w-100 mb-5">
            Sua consulta já vai começar. O profissional de saúde está se
            preparando para iniciar o atendimento.
          </p>
          <div className="d-flex justify-content-end flex-lg-row flex-column-reverse w-100 footer-modal-buttons">
            <Button
              onClick={() => {
                closeModal()
              }}
            >
              Ok, entendi
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AttendanceLate
